import { createSlice } from '@reduxjs/toolkit';
import { ApiHelper } from '../../utils/apiHelper';

const initialState = {
  emails: [], // Boş bir dizi ile başlatıyoruz
  selectedEmails: [],
  loading: false,
  error: null
};

const mailSlice = createSlice({
  name: 'mail',
  initialState,
  reducers: {
    setSelectedEmails: (state, action) => {
      state.selectedEmails = action.payload;
    },
    selectAll: (state) => {
      state.selectedEmails = state.emails.map(email => email.email);
    },
    selectNewsletterSubscribers: (state) => {
      state.selectedEmails = state.emails
        .filter(email => email.newsletterSubscription)
        .map(email => email.email);
    },
    clearSelection: (state) => {
      state.selectedEmails = [];
    },
    // Fetch actions
    fetchMailsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchMailsSuccess: (state, action) => {
      state.loading = false;
      console.log("action", action.payload);
      state.emails = action.payload.emails;
    },
    fetchMailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  }
});

export const { 
  setSelectedEmails, 
  selectAll, 
  selectNewsletterSubscribers, 
  clearSelection,
  fetchMailsStart,
  fetchMailsSuccess,
  fetchMailsFailure 
} = mailSlice.actions;

// Thunk action for fetching mails
export const fetchAllMails = () => async (dispatch) => {
  try {
    dispatch(fetchMailsStart());
    // API çağrısı burada yapılacak
    const response = await ApiHelper.get('/admin/user-mails'); // API endpoint'inize göre değiştirin
    
    console.log('API Response:', response.data); // Debug için response'u logla
    
    // API response yapısına göre veriyi işle
    if (response.data.code === '00000') {
      // Başarılı response
      const mails = response.data.response || response.data.emails || response.data || [];
      console.log('Processed mails:', mails); // İşlenmiş veriyi logla
      dispatch(fetchMailsSuccess({ emails: mails }));
    } else {
      // API'den hata döndü
      dispatch(fetchMailsFailure(response.data.message || 'Mail bilgileri alınamadı'));
    }
  } catch (error) {
    console.error('Fetch error:', error); // Hata detayını logla
    dispatch(fetchMailsFailure(error.message || 'Bir hata oluştu'));
  }
};

export const sendBatchMail = (mailSubject, mailContent, selectedEmails) => async (dispatch) => {
    try {
        const response = await ApiHelper.post('/admin/send-batch-mail', {
        subject: mailSubject,
        content: mailContent,
        emails: selectedEmails
        });
        if (response.data.code === '00000') {
        console.log("Mail gönderildi:", response.data.response);
        } else {
        console.error("Mail gönderilemedi:", response.data.message);
        }
    } catch (error) {
        console.error("Mail gönderme hatası:", error.message);
    }
}

export default mailSlice.reducer;